import React from "react";
import "bootstrap/js/collapse";
export default ({ title }) => (
    <nav className="navbar navbar-inverse navbar-fixed-top" role="navigation">
        <div className="navbar-header">
            <a
                className="navbar-brand text-white"
                href="https://micetf.fr"
                title="Des Outils Pour La Classe"
            >
                MiCetF
            </a>
            <button
                type="button"
                className="navbar-toggle"
                data-toggle="collapse"
                data-target="#navbarMobile"
            >
                <span className="sr-only">Toggle navigation</span>
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
            </button>
        </div>
        <div className="collapse navbar-collapse" id="navbarMobile">
            <div className="nav navbar-nav">
                <span className="navbar-brand text-white">></span>
                <span className="navbar-brand text-white">{title}</span>
            </div>
            <div className="navbar-right mr-2">
                <ul className="nav navbar-nav pull-left">
                    <li className="mr-2">
                        <form
                            action="https://www.paypal.com/cgi-bin/webscr"
                            method="post"
                            target="_top"
                        >
                            <button
                                className="btn btn-link navbar-btn"
                                title="Si vous pensez que ces outils le méritent... Merci !"
                                type="submit"
                            >
                                <span className="glyphicon glyphicon-heart" />
                            </button>
                            <input type="hidden" name="cmd" value="_s-xclick" />
                            <input
                                type="hidden"
                                name="hosted_button_id"
                                value="Q2XYVFP4EEX2J"
                            />
                        </form>
                    </li>
                    <li className="mr-2">
                        <a
                            className="btn btn-link"
                            title="Chercher un outil sur micetf.fr..."
                            href="https://micetf.fr/outils"
                            target="_blank"
                        >
                            <span className="glyphicon glyphicon-search" />
                        </a>
                    </li>
                    <li>
                        <a
                            className="btn btn-link"
                            title="Pour contacter le webmaster..."
                            href="mailto:webmaster@micetf.fr?subject=Au sujet de /Compteur"
                        >
                            <span className="glyphicon glyphicon-envelope" />
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </nav>
);



// WEBPACK FOOTER //
// ./src/components/navbar.js